import gsap from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';
import { Sizes } from '../utils';

gsap.registerPlugin( Draggable, InertiaPlugin );

export class DragItem {
	constructor( selector, options = {} ) {
		this.elements = gsap.utils.toArray( selector );
		this.sizes = new Sizes();
		this.options = {
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
			bounds: options?.bounds,
		};
		this.isEnable = false;

		this.dragFuncs = [];
	}

	init() {
		if ( ! this.elements?.length ) return;
		if ( this.options.devices.includes( this.sizes.device ) ) {
			const vars = {};
			if ( this.options.bounds ) {
				if ( this.options.bounds === 'window' ) {
					vars.bounds = window;
				} else {
					vars.bounds = this.options.bounds;
				}
			}
			this.dragFuncs = Draggable.create( this.elements, {
				...vars,
				inertia: true,
			} );
			this.isEnable = true;
		}
	}

	kill() {
		this.dragFuncs.forEach( ( draggable, index ) => {
			draggable.kill();
			this.dragFuncs[ index ] = null;
		} );
		gsap.killTweensOf( this.elements );
		gsap.set( this.elements, { clearProps: 'all' } );
		this.dragFuncs = [];
		this.isEnable = false;
	}

	resize() {
		if ( this.isEnable ) {
			this.kill();
		}
		if ( this.options.devices.includes( this.sizes.device ) ) {
			this.init();
		}
	}

	destroy() {
		this.kill();
		this.elements = null;
		this.sizes = null;
		this.options = null;
		this.dragFuncs = null;
		this.isEnable = null;
	}
}
